<template>
  <div>
    <router-view/>
  </div>
</template>
<script>

export default {
  name: 'App',
  data(){
    return {
      
    }
  },
  watch: {
   
  },
  components: { },
  methods:{},
  mounted(){
    
  },
  async created(){
    
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #0e0d0d;
}
</style>
